import type { FC } from 'react'
import type { GrandImageProps } from './GrandImage'
import { GrandImage } from './GrandImage'

export type HeroImageProps = GrandImageProps

const HeroImage: FC<HeroImageProps> = (props) => {
  return <GrandImage fill objectFit="cover" priority quality={75} sizes="100vw" {...props} />
}

export default HeroImage
